/**
 * @generated SignedSource<<92835b0d1b9d81504423f56f52fa18ab>>
 * @relayHash 26e65e1439b7b32bc10c0cd34eea97ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4aef61af84a05aa0bdeb2ea4ebb724a7401bfe4e9b756a8f97e6b309fa856023

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectViewAggInnerQuery$variables = {
  cloudId: string;
  containerId: string;
  projectKey: string;
};
export type ProjectViewAggInnerQuery$data = {
  readonly projects_byKey: {
    readonly id: string;
    readonly url: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectViewHeaderAgg" | "ProjectViewSidebarAgg">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectViewSidebarAgg_MercuryWorkspace">;
};
export type ProjectViewAggInnerQuery = {
  response: ProjectViewAggInnerQuery$data;
  variables: ProjectViewAggInnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "url"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "picture"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "kind": "ScalarField",
  "name": "count"
},
v12 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v13 = [
  (v8/*: any*/)
],
v14 = [
  {
    "concreteType": "TownsquareHighlightEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v13/*: any*/)
  }
],
v15 = [
  (v5/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "name": "dark"
},
v17 = {
  "kind": "ScalarField",
  "name": "light"
},
v18 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v19 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v20 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v21 = {
  "kind": "ScalarField",
  "name": "description"
},
v22 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v23 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v24 = [
  (v8/*: any*/),
  (v5/*: any*/),
  (v10/*: any*/),
  (v9/*: any*/)
],
v25 = [
  {
    "concreteType": "TownsquareLinkEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareLink",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v4/*: any*/),
          (v10/*: any*/)
        ]
      }
    ]
  },
  (v23/*: any*/)
],
v26 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v27 = [
  (v7/*: any*/),
  (v5/*: any*/)
],
v28 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isUser"
},
v29 = [
  (v8/*: any*/),
  {
    "kind": "ScalarField",
    "name": "accountId"
  },
  (v5/*: any*/),
  (v28/*: any*/),
  (v10/*: any*/),
  (v9/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "concreteType": "AtlassianAccountUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "jobTitle"
          }
        ]
      }
    ],
    "type": "AtlassianAccountUser"
  }
],
v30 = {
  "kind": "ScalarField",
  "name": "value"
},
v31 = [
  (v5/*: any*/),
  (v10/*: any*/),
  (v21/*: any*/)
],
v32 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v33 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v34 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v18/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectViewAggInnerQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TownsquareProject",
        "kind": "LinkedField",
        "name": "projects_byKey",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "ProjectViewHeaderAgg"
          },
          {
            "kind": "FragmentSpread",
            "name": "ProjectViewSidebarAgg"
          }
        ]
      },
      {
        "args": (v6/*: any*/),
        "kind": "FragmentSpread",
        "name": "ProjectViewSidebarAgg_MercuryWorkspace"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectViewAggInnerQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TownsquareProject",
        "kind": "LinkedField",
        "name": "projects_byKey",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v5/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              },
              (v11/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "isPrivate"
          },
          {
            "args": [
              (v12/*: any*/)
            ],
            "concreteType": "TownsquareProjectUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v13/*: any*/)
              }
            ],
            "storageKey": "updates(first:10)"
          },
          {
            "alias": "learningHighlights",
            "args": [
              (v12/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "LEARNING"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v14/*: any*/),
            "storageKey": "highlights(first:10,type:\"LEARNING\")"
          },
          {
            "alias": "riskHighlights",
            "args": [
              (v12/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "RISK"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v14/*: any*/),
            "storageKey": "highlights(first:10,type:\"RISK\")"
          },
          {
            "alias": "decisionHighlights",
            "args": [
              (v12/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "DECISION"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v14/*: any*/),
            "storageKey": "highlights(first:10,type:\"DECISION\")"
          },
          (v10/*: any*/),
          {
            "concreteType": "TownsquareProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canAddTags"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTags"
              },
              {
                "kind": "ScalarField",
                "name": "canManageOwnership"
              },
              {
                "kind": "ScalarField",
                "name": "canAddRelatedLink"
              },
              {
                "kind": "ScalarField",
                "name": "canEditRelatedLink"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveRelatedLink"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedFocusAreas"
              },
              {
                "concreteType": "TownsquareProjectAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareFocusAppCapabilities",
                    "kind": "LinkedField",
                    "name": "focus",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canViewFocusAreas"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditStartDate"
              },
              {
                "kind": "ScalarField",
                "name": "canAddContributors"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveContributors"
              },
              {
                "kind": "ScalarField",
                "name": "canAddWatchers"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveWatchers"
              },
              {
                "kind": "ScalarField",
                "name": "canManageAccess"
              },
              {
                "kind": "ScalarField",
                "name": "canEditCustomFields"
              }
            ]
          },
          {
            "concreteType": "TownsquareWorkspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": (v15/*: any*/)
          },
          {
            "concreteType": "TownsquareIconURIs",
            "kind": "LinkedField",
            "name": "iconUrl",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/)
                ]
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 5
              }
            ],
            "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
            "kind": "LinkedField",
            "name": "linkedJiraWorkItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v18/*: any*/)
                ]
              },
              {
                "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "summary"
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "permission",
                                "value": "EDIT_ISSUES"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "hasProjectPermission",
                            "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                          },
                          {
                            "concreteType": "JiraStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "statusId"
                              },
                              (v10/*: any*/),
                              {
                                "concreteType": "JiraStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategory",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "statusCategoryId"
                                  },
                                  (v10/*: any*/),
                                  (v5/*: any*/)
                                ]
                              },
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "issueTypeId"
                              },
                              (v10/*: any*/),
                              (v5/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      (v20/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ]
              }
            ],
            "storageKey": "linkedJiraWorkItems(first:5)"
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v10/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v21/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v22/*: any*/)
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v24/*: any*/)
          },
          {
            "concreteType": "TownsquareLinkConnection",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": (v25/*: any*/)
          },
          {
            "alias": "workTrackingLinks",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              {
                "kind": "Literal",
                "name": "type",
                "value": "WORK_TRACKING"
              }
            ],
            "concreteType": "TownsquareLinkConnection",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": (v25/*: any*/),
            "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
          },
          {
            "concreteType": "TownsquareFusionDetails",
            "kind": "LinkedField",
            "name": "fusion",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "synced"
              },
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v19/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v26/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v10/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v27/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v27/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v20/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          {
            "kind": "ScalarField",
            "name": "creationDate"
          },
          {
            "concreteType": "TownsquareContributorConnection",
            "kind": "LinkedField",
            "name": "contributors",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareContributorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareContributor",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareTeamContributor",
                        "kind": "LinkedField",
                        "name": "teamContributor",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "contributingMembers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v29/*: any*/)
                                  }
                                ]
                              },
                              (v11/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "smallAvatarImageUrl"
                              },
                              {
                                "concreteType": "TeamMemberConnectionV2",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TeamMemberEdgeV2",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TeamMemberV2",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "member",
                                            "plural": false,
                                            "selections": (v24/*: any*/)
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "profileUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "state"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "permission"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isVerified"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "userContributor",
                        "plural": false,
                        "selections": (v29/*: any*/)
                      }
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareProjectDependencyConnection",
            "kind": "LinkedField",
            "name": "dependencies",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectDependencyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectDependency",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "linkType"
                      },
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "incomingProject",
                        "plural": false,
                        "selections": (v15/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "outgoingProject",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v10/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareThemeURIs",
                                "kind": "LinkedField",
                                "name": "square",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v16/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddRelatedProjects"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveRelatedProjects"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedGoals"
              }
            ]
          },
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "goals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v4/*: any*/),
                      (v10/*: any*/),
                      {
                        "concreteType": "TownsquareStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalTypeIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/)
                            ]
                          },
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareProjectAccessConnection",
            "kind": "LinkedField",
            "name": "access",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectAccessEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "role"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v15/*: any*/),
                        "type": "User",
                        "abstractKey": "__isUser"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v15/*: any*/),
                        "type": "AppUser"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v15/*: any*/),
                        "type": "AtlassianAccountUser"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v15/*: any*/),
                        "type": "CustomerUser"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "accessLevel"
          },
          (v23/*: any*/),
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v26/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v31/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v20/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v26/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v31/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v20/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v26/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v31/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v20/*: any*/)
                            ]
                          },
                          {
                            "args": (v32/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v5/*: any*/),
                                      (v28/*: any*/),
                                      (v10/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  },
                                  (v33/*: any*/)
                                ]
                              },
                              (v34/*: any*/),
                              (v23/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v32/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v26/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v10/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "args": (v32/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v30/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v20/*: any*/)
                            ]
                          },
                          {
                            "args": (v32/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v8/*: any*/)
                                    ]
                                  },
                                  (v33/*: any*/)
                                ]
                              },
                              (v34/*: any*/),
                              (v23/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v32/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "MercuryQueryApi",
        "kind": "LinkedField",
        "name": "mercury",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "MercuryWorkspaceContext",
            "kind": "LinkedField",
            "name": "workspaceContext",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "activationId"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4aef61af84a05aa0bdeb2ea4ebb724a7401bfe4e9b756a8f97e6b309fa856023",
    "metadata": {},
    "name": "ProjectViewAggInnerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e114477b01793f61c4dd405d80dc6c5a";

export default node;
